import { Component, Input, OnInit } from '@angular/core';

export interface TitleSettings {
  title: string;
  description: string;
  icon: string;
}

@Component({
  selector: 'report-card-title',
  templateUrl: './card-title.component.html',
  styleUrls: ['./card-title.component.scss']
})
export class CardTitleComponent implements OnInit {

  @Input() titleSettings: TitleSettings;

  constructor() { }

  ngOnInit() {
  }

}
